import React, { useRef, useState, useEffect } from 'react';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './TestimonialVideo.module.scss';
import YoutubePopup from '@Theme/natucare/components/YoutubePopup/YoutubePopup';
import Picture from '@Theme/natucare/components/Picture/Picture';
const TestimonialVideo = _ref => {
  var _youtube$thumbnail;
  let {
    video,
    youtube
  } = _ref;
  // if (!video?.mp4 && !video?.webm && !video?.thumbnail) {
  //   return false;
  // }

  const ioOptions = {
    root: null,
    threshold: 0.1
  };
  const {
    0: isPlaying,
    1: setIsPlaying
  } = useState(false);
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const {
    0: isLoadedFile,
    1: setIsLoadedFile
  } = useState(false);
  const ref = useRef();
  const handlePopup = () => {
    setIsOpen(!isOpen);
  };
  const handleClick = () => {
    ref.current.load();
    ref.current.play();
    ref.current.onended = () => {
      ref.current.load();
      setIsPlaying(false);
    };
    setIsPlaying(true);
  };
  if (!youtube) {
    useEffect(() => {
      if (ref) {
        const setIntersectingToEntry = _ref2 => {
          let [entry] = _ref2;
          if (entry.isIntersecting) {
            setIsLoadedFile(true);
          }
        };
        const currentTarget = ref.current;
        const observer = new IntersectionObserver(setIntersectingToEntry, ioOptions);
        if (!isLoadedFile && currentTarget && 'IntersectionObserver' in window) {
          observer.observe(currentTarget);
        }
        return () => {
          observer.unobserve(currentTarget);
        };
      }
    }, [ref, ioOptions]);
  }
  return /*#__PURE__*/React.createElement("div", {
    onClick: video ? handleClick : handlePopup,
    className: `${styles.root} ${isPlaying ? styles.rootIsPlaying : ''}`
  }, video && !youtube && /*#__PURE__*/React.createElement("video", {
    muted: true,
    poster: video === null || video === void 0 ? void 0 : video.thumbnail,
    className: `${styles.rootVideo} ${isPlaying ? styles.rootVideoPlaying : ''}`,
    ref: ref
  }, /*#__PURE__*/React.createElement("source", Object.assign({}, !isLoadedFile ? {
    'data-src': video.webm
  } : {
    src: video.webm
  }, {
    type: "video/webm"
  })), /*#__PURE__*/React.createElement("source", Object.assign({}, !isLoadedFile ? {
    'data-src': video.mp4
  } : {
    src: video.mp4
  }, {
    type: "video/mp4"
  }))), youtube && !video && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(YoutubePopup, {
    isOpen: isOpen,
    id: youtube.id,
    handler: handlePopup
  }), (youtube === null || youtube === void 0 ? void 0 : (_youtube$thumbnail = youtube.thumbnail) === null || _youtube$thumbnail === void 0 ? void 0 : _youtube$thumbnail.src) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: youtube.thumbnail.src
    },
    alt: youtube === null || youtube === void 0 ? void 0 : youtube.thumbnail.alt,
    pictureClassname: styles.rootThumbnail,
    imgClassname: styles.rootThumbnailImg
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootIconWrapper
  }, /*#__PURE__*/React.createElement(Icon, {
    size: {
      width: 73,
      height: 83
    },
    classname: styles.rootIcon,
    name: "playIcon"
  })));
};
export default TestimonialVideo;